/* ==========================================================================
   AMALGAM TAILOR MADE NAV. G&V 2026
   Desktop: the inline masthead strip is pure CSS (amalgam-nav-tailor-made.css).
   Under 1300px: the header Menu button opens #tmMobileMenu (the same TM links)
   instead of Horizon's drawer, which would show the global Editions menu.
   ========================================================================== */
(function () {
  'use strict';
  var panel = document.getElementById('tmMobileMenu');
  if (!panel) return;
  var closeBtn = panel.querySelector('.tm-mobile-menu__close');
  var lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    panel.hidden = false;
    document.body.classList.add('tm-mobile-menu-open');
    if (closeBtn) closeBtn.focus();
  }
  function close() {
    panel.hidden = true;
    document.body.classList.remove('tm-mobile-menu-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* Window capture runs before Horizon's document-capture on:click, so its drawer never opens. */
  window.addEventListener('click', function (e) {
    if (window.innerWidth > 1300) return;
    var burger = e.target.closest ? e.target.closest('.header__icon--menu') : null;
    if (!burger) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var details = document.getElementById('Details-menu-drawer-container');
    if (details) details.removeAttribute('open');
    open();
  }, true);

  if (closeBtn) closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) close();
  });
  window.addEventListener('resize', function () {
    if (window.innerWidth > 1300 && !panel.hidden) close();
  });
})();
